import { render, staticRenderFns } from "./AlertConfig.vue?vue&type=template&id=32d21a53&"
import script from "./AlertConfig.vue?vue&type=script&lang=js&"
export * from "./AlertConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports